import QRCode from "qrcode";

const SIZE = 2000;
const INK = "#1f1d1a";
const IVORY = "#fbf8f1";
/** Fraction of the code's width the logo plate covers. Level H tolerates
 *  30% of modules being lost; a 24% square is under 6% of the area. */
const PLATE = 0.24;

/**
 * A QR code for `text` with the अ mark on an ivory plate in the centre,
 * as a print-resolution PNG.
 */
export async function brandedQrPng(text: string): Promise<Blob> {
  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, text, {
    errorCorrectionLevel: "H",
    width: SIZE,
    margin: 4,
    color: { dark: INK, light: IVORY },
  });
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Canvas is unavailable in this browser.");
  }

  const logo = new Image();
  logo.src = "/logo.png";
  await logo.decode();

  const plate = SIZE * PLATE;
  const origin = (SIZE - plate) / 2;
  ctx.fillStyle = IVORY;
  ctx.beginPath();
  ctx.roundRect(origin, origin, plate, plate, plate * 0.18);
  ctx.fill();

  const box = plate * 0.7;
  const scale = Math.min(box / logo.width, box / logo.height);
  const width = logo.width * scale;
  const height = logo.height * scale;
  ctx.drawImage(logo, (SIZE - width) / 2, (SIZE - height) / 2, width, height);

  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (blob) =>
        blob
          ? resolve(blob)
          : reject(new Error("The QR code couldn't be encoded.")),
      "image/png",
    ),
  );
}
